<template>
	<div class="animated fadeIn">

		<div class="row">
			<div class="col-xs-12">
				<h2>
					<i class="fa fa-fire text-success"></i>
					<span v-show="!topic.editMode">创建专题</span>
					<span v-show="topic.editMode">编辑专题</span>
				</h2>
				<div class="pull-right">
					<CreateSaveButton :entity="topic" :callback="save"/>
				</div>
			</div>
		</div>

		<div class="row">

			<div class="col-xs-12 m-t-md">


				<div class="form-group">
					<label class="control-label">标题</label>
					<input type="text" class="form-control" v-model="topic.name">
				</div>


				<div class="form-group">
					<label class="control-label">简介</label>
					<textarea class="form-control" rows="6" v-model="topic.description"
					          placeholder="此处填写专题简介……"></textarea>
				</div>

				<div class="form-group">
					<label class="control-label">专题主题样式</label>
					<ThemePagerSelection :activeTheme="topic.theme"/>
				</div>



				<NbExpanding>
					<div class="form-group" v-if="topic.theme && topic.theme.editComponent">
						<label class="control-label">专题样式附加属性修改</label>
						<div class="mt5">
							<component ref="themeEditComponent" v-bind:is="topic.theme.editComponent"
							           v-model="topic.remark"></component>
						</div>

					</div>
				</NbExpanding>

				<div class="form-group">
					<label class="control-label">专题首页样式类型</label>
					<select class="form-control m-b"
					        name="type" v-model="topic.type">
						<option v-for="type in topic.TypeList" :value="type.value">{{type.name}}</option>
					</select>
				</div>


				<div class="form-group">
					<label class="control-label">访问地址(只能包含英文，数字以及“-”和“_”)</label>
					<input type="text" class="form-control" v-model="topic.location">
				</div>


				<div class="form-group">
					<label class="control-label">封面</label>
					<span class="italic" v-if="topic.theme && topic.theme.logoRemark">{{topic.theme.logoRemark}}</span>
					<div>
						<NbTank :tank="topic.poster"/>
					</div>
				</div>

				<div class="form-group" v-if="topic.type === 'ARTICLE'">
					<label class="control-label">首页文章</label>
					<ArticlePagerSelection :activeArticle="topic.article"/>
				</div>

				<div class="form-group" v-if="topic.type === 'SCENERY'">
					<label class="control-label">定制页面</label>
					<SceneryPagerSelection :activeScenery="topic.scenery"/>
				</div>

			</div>
			<div class="col-xs-12">
				<label class="control-label">菜单结构</label>
				<TopicMenuFrame :topic="topic"/>
			</div>

			<div class="col-xs-12 m-t-md">
				<div class="alert alert-danger" v-show="topic.errorMessage">
					{{topic.errorMessage}}
				</div>
				<div class="pull-right">
					<CreateSaveButton :entity="topic" :callback="save"/>
				</div>
			</div>
		</div>

	</div>

</template>
<script>
	import {Notification} from 'element-ui';
	import Topic from '../../../common/model/topic/Topic'
	import NbTank from '../../../common/widget/NbTank'
	import NbExpanding from '../../../common/widget/NbExpanding.vue'
	import CreateSaveButton from "../widget/CreateSaveButton.vue"
	import PanelBody from './widget/PanelBody.vue'
	import TopicMenuFrame from './widget/TopicMenuFrame.vue'
	import ArticlePagerSelection from '../article/Selection.vue'
	import SceneryPagerSelection from '../scenery/Selection.vue'
	import ThemePagerSelection from '../theme/Selection.vue'

	export default {

		data () {
			return {
				topic: new Topic()
			}
		},
		components: {
			NbTank,
			NbExpanding,
			CreateSaveButton,
			TopicMenuFrame,
			PanelBody,
			ArticlePagerSelection,
			SceneryPagerSelection,
			ThemePagerSelection
		},
		computed: {
			themeEditComponent(){

				if (this.topic.theme && this.topic.theme.editComponent) {
					return this.$refs.themeEditComponent;
				} else {
					return null;
				}

			}
		},
		watch: {},
		methods: {
			save(){
				let that = this;

				//提交之前判断专题样式修改的情况。
				if (this.themeEditComponent) {
					let oldMsg = this.topic.errorMessage;
					if (!this.themeEditComponent.validate()) {
						this.topic.errorMessage = "请修正专题样式中的错误后再提交";
						return;
					} else {
						this.topic.errorMessage = oldMsg;
					}
				}


				this.topic.httpSave(function (response) {


					Notification.success({
						message: that.topic.editMode ? '修改专题成功！' : '创建专题成功！'
					});

					that.$router.push("/cgd/by/topic/list");

				});
			}
		},


		mounted(){

			let that = this;
			this.topic.editMode = true;
			this.topic.poster.privacy = false;
			this.topic.id = this.$store.state.route.params.id;
			if (this.topic.id) {
				this.topic.httpDetail();
			} else {
				this.topic.menus = [];
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Create.vue?510ef1cf